export default "__VITE_ASSET__43fb693a__"